import React, { useEffect, useState } from 'react';
import styles from './styles/individual-view.module.css';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Avatar from '@mui/material/Avatar';

import {IndividualViewChart} from 'components/UI/Chart';
import { ReactComponent as OxygenIcon } from '../../utils/assets/Path.svg';
import { ReactComponent as AltitudeIcon } from '../../utils/assets/Path3.svg';
import { ReactComponent as AirQualityIcon } from '../../utils/assets/Path4.svg';
import { ReactComponent as HumidityIcon } from '../../utils/assets/path5.svg';
import { ReactComponent as BarometricIcon } from '../../utils/assets/path6.svg';
import { ReactComponent as HeartIcon } from '../../utils/assets/heart.svg';

import { ReactComponent as TempatureIcon } from '../../utils/assets/temprature.svg';
import { ReactComponent as BodyTemperatureIcon } from '../../utils/assets/body-temperature.svg';
import { ReactComponent as PerfusionIcon } from '../../utils/assets/perfusion.svg';
import { ReactComponent as HRRIcon } from '../../utils/assets/hrr.svg';
import { ReactComponent as HRVIcon } from '../../utils/assets/HRV.svg';
import { ReactComponent as SPOIcon } from '../../utils/assets/Vo2.svg';

import { useNavigate, useLocation } from 'react-router-dom';
import useAxiosPrivate from '../../utils/hooks/useAxiosPrivate';
import Jsonpack from 'jsonpack';
import { Button } from '@material-ui/core';
import { ReactComponent as EditIconTakeNote } from '../../utils/assets/editIcon_TakeNote.svg';
import AddPrivateNote from './add_private_note';
import useSSE from '../../utils/hooks/useSSE';
import ExitConfirmDialog from '../Report/ExitConfirmDialog';

import { SingleVital } from './SingleVital';
export default function ViewUser() {
	const axios = useAxiosPrivate();
	let navigate = useNavigate();
	const location = useLocation();
	const item = location.state;

	// eslint-disable-next-line
	const [members, setMembers] = useState([]);
	// const [user, setUser] = useState([]);
	const [fData, setFData] = useState([]);
	const [fromDate, setFromDate] = useState('');
	const [open, setOpen] = useState(false);
	const [showExitConfirm, setShowExitConfirm] = useState(false);

	// This page is fluid-width and shouldn't force the site-wide 1300px
	// minimum (which would otherwise show a horizontal scrollbar here).
	useEffect(() => {
		document.documentElement.classList.add('individual-view-active');
		return () => {
			document.documentElement.classList.remove('individual-view-active');
		};
	}, []);

	const direct = () => {
		// Navigate back to DetailView if coming from Compare, otherwise to Dashboard
		if (location.state?.fromCompare) {
			navigate(-1); // Go back to DetailView
		} else {
			navigate('/dashboard');
		}
	};

	const handleConfirmExit = () => {
		setShowExitConfirm(false);
		navigate(-1);
	};

	const getData = async () => {
		if (fromDate === '') {
			const { data } = await axios.post('/team/data', {
				only_updates: false,
				user_ids: [item.user_id],
			});
			const json = Jsonpack.unpack(data.data);
			setFData(json);

			const results = Object.entries(json)
				// eslint-disable-next-line
				.map((item) => {
					if (item[1].length) {
						if (item[1][item.length - 1]?.reading_time) {
							return new Date(item[1][item.length - 1].reading_time);
						}
					}
				})
				.filter((record) => record);

			if (results.length) {
				setFromDate(new Date(Math.max(...results)).toString());
			}
		} else if (fromDate !== '') {
			const { data } = await axios.post('/team/data', {
				only_updates: true,
				user_ids: [item.user_id],
				from_time: fromDate,
			});

			const json = Jsonpack.unpack(data.data);
			setFData(json);

			const results = Object.entries(json)
				// eslint-disable-next-line
				.map((item) => {
					if (item[1].length) {
						if (item[1][item.length - 1]?.reading_time) {
							return new Date(item[1][item.length - 1].reading_time);
						}
					}
				})
				.filter((record) => record);

			if (results.length) {
				setFromDate(new Date(Math.min(...results)).toString());
			}
		}
	};

	// Handle SSE data updates
	const handleSSEData = React.useCallback((parsedData) => {
		console.log('SSE data received:', parsedData);

		// Basic shape guard
		if (!parsedData || !parsedData.data) {
			return;
		}

		const userData = parsedData.data[item.user_id];

		// If there's no entry for this user, or it's an empty array, do nothing
		if (
			!userData ||
			(Array.isArray(userData) && userData.length === 0)
		) {
			return;
		}

		// Only update state when we actually have data for this user
		setFData(parsedData.data);
	}, [item.user_id]);

	// Handle SSE errors
	const handleSSEError = React.useCallback((error) => {
		console.error('SSE Error:', error);
	}, []);

	// Use SSE hook
	useSSE(
		`/user/data/${item.user_id}`,
		handleSSEData,
		handleSSEError
	);

	

	useEffect(() => {
		getData();
		// eslint-disable-next-line
	}, []);

	// Check if coming from Compare view
	const fromCompare = location.state?.fromCompare === true;

	const handleClick = (event) => {
		event.preventDefault();
		navigate('/dashboard');
	};

	const breadcrumbs = [
		<p key="dashboard" onClick={handleClick} className={`${styles.breadcrumbs} ${styles.breadcrumbLink}`}>
			Dashboard
		</p>,
		<p key="user" className={`${styles.breadcrumbs} ${styles.breadcrumbCurrent}`}>
			{location.state?.first_name}&nbsp; {location.state?.last_name}
		</p>,
	];

	// if (fData.length === 0) {
	// 	return <p>Please wait...</p>;
	// }

	return (
		<div className={styles.page}>
			{!fromCompare && (
				<div className={styles.container}>
					<div className={styles.tab}>
						<Breadcrumbs
							separator={
								<NavigateNextIcon
									fontSize="small"
									sx={{ color: 'var(--primary-text-color)' }}
								/>
							}
							aria-label="breadcrumb"
						>
							{breadcrumbs}
						</Breadcrumbs>
					</div>
				</div>
			)}
			<div className={styles.detailCard}>
				<AddPrivateNote
					setOpen={setOpen}
					open={open}
					players_id={item?.user_id}
				/>
				<div className={styles.container}>
				<div className={styles.header}>
					<div className={styles.inside}>
						<div className={styles.box}>
							<div className={styles.item2}>
								{' '}
								<Avatar
									alt={location.state?.first_name}
									src={location.state.avatar_url}
									sx={{ width: 46, height: 46 }}
								/>
							</div>
							<div className={styles.item3}>
								{' '}
								<p className={styles.tdText}>
									{' '}
									{location.state?.first_name}&nbsp; {location.state?.last_name}
								</p>
							</div>
						</div>
						<div className={styles.boxButton}>
							<div className={styles.item4}>
								<input
									type="button"
									className={styles.searchButton}
									value="Back"
									onClick={direct}
								/>
							</div>
							<div className={styles.item4}>
								<Button
									fullWidth
									size="large"
									style={{
										fontSize: '14px',
										lineHeight: '1.25rem',
										fontFamily: 'Poppins',
										fontWeight: 500,
										fontStyle: 'normal',
										width: 120,
										height: 32,
										backgroundColor: '#0F9BB0',
										color: 'white',
										textTransform: 'none',
									}}
									startIcon={<EditIconTakeNote />}
									onClick={() => setOpen(true)}
								>
									Take notes
								</Button>
							</div>
						</div>
					</div>
				</div>
				</div>
				{/* Health */}
				<div className={styles.container}>
				<div className={styles.container2}>
					<div className={styles.inside2}>
						<p className={styles.sectionHeader}>{'Health'}</p>
						<div className={styles.boxNew}>
							<SingleVital
								fData={fData}
								item={item}
								Icon={OxygenIcon}
								title="Oxygen"
								subTitle="%"
								field="spo2"
								variant="individual"
							/>
							<SingleVital
								fData={fData}
								item={item}
								Icon={HeartIcon}
								title="Pulse Rate"
								subTitle="bpm"
								field="heart_rate"
								variant="individual"
							/>

							{/*  Commented out for demo purposes */}
							<SingleVital
								fData={fData}
								item={item}
								Icon={SPOIcon}
								title="SpO₂ Variability"
								subTitle="mL/s"
								field="spv"
								variant="individual"
							/>

							<SingleVital
								fData={fData}
								item={item}
								Icon={PerfusionIcon}
								title="Perfusion Index"
								subTitle="%"
								field="pi"
								variant="individual"
							/>
							<SingleVital
								fData={fData}
								item={item}
								Icon={HRVIcon}
								title="PRV"
								subTitle="ms"
								field="hrv"
								variant="individual"
							/>
							{/* TODO */}
						</div>
						<div className={styles.boxNew}>

							{/*  Commented out for demo purposes */}
							<SingleVital
								fData={fData}
								item={item}
								Icon={HRRIcon}
								title="PRR"
								subTitle="%"
								field="hrr"
								variant="individual"
							/>
							<SingleVital
								fData={fData}
								item={item}
								Icon={BodyTemperatureIcon}
								title="Body Temperature"
								subTitle="°F"
								field="body_temperature"
								variant="individual"
							/>
							{/* <SingleVital
                fData={fData}
                item={item}
                Icon={AvgO2}
                title="Ave VO2"
                subTitle="mL/kg/min"
                field="hrv"
              />
              <SingleVital
                fData={fData}
                item={item}
                Icon={MaxO2}
                title="Max VO2"
                subTitle="mL/kg/min"
                field="hrv"
              /> */}
						</div>
					</div>
				</div>
				</div>
				{/* Environment */}
				<div className={styles.container}>
				<div className={styles.container2}>
					<div className={styles.inside2}>
						<p className={styles.sectionHeader}>{'Environment'}</p>
						<div className={styles.boxNew}>
							<SingleVital
								fData={fData}
								item={item}
								Icon={TempatureIcon}
								title="Weather"
								subTitle="°F"
								field="temp"
								variant="individual"
							/>

							<SingleVital
								fData={fData}
								item={item}
								Icon={AltitudeIcon}
								title="Altitude"
								subTitle="feet"
								field="altitude"
								variant="individual"
							/>

							<SingleVital
								fData={fData}
								item={item}
								Icon={AirQualityIcon}
								title="Air Quality Index"
								subTitle="moderate"
								field="air_quality"
								variant="individual"
							/>

							<SingleVital
								fData={fData}
								item={item}
								Icon={HumidityIcon}
								title="Humidity"
								subTitle="%"
								field="humidity"
								variant="individual"
							/>

							<SingleVital
								fData={fData}
								item={item}
								Icon={BarometricIcon}
								title="Barometric Pressure"
								subTitle="in. HG"
								field="biometric_pressure"
								variant="individual"
							/>
						</div>
					</div>
				</div>
				</div>
				<div className={styles.container}>
				<div className={styles.container3}>
					<div className={styles.inside2}>
						<p className={styles.sectionHeader}>{'Live Reading'}</p>
						<div
							style={{
								display: 'flex',
								justifyContent: 'flex-end',
								alignItems: 'center',
							}}
						>
							<div
								style={{
									borderBottom: '3px solid #FFFFFF',
									width: '1.5rem',
									marginRight: '5px',
									marginBottom: '1rem',
								}}
							></div>
							<p className={styles.tittleText}>SpO₂ (%)</p>
							<div
								style={{
									borderBottom: '3px dashed #FFFFFF',
									width: '1.5rem',
									marginRight: '5px',
									marginLeft: '2rem',
									marginBottom: '1rem',
								}}
							></div>
							<p className={styles.tittleText}>Pulse Rate (bpm)</p>
						</div>
						<IndividualViewChart fData={fData[String(item?.user_id)]} height={250} />
					</div>
				</div>
			</div>
			</div>
			<ExitConfirmDialog
				open={showExitConfirm}
				onClose={() => setShowExitConfirm(false)}
				onConfirm={handleConfirmExit}
				title="Are you sure you want to exit?"
			/>
		</div>
	);
}
